import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconExternalLink } from "@tabler/icons-react";
import { Teammate } from "@/pages/mcp/mcpSlice";
import { FC, useMemo } from "react";

interface DatamatesSelectorProps {
  datamates: Teammate[];
  selectedDatamate: string;
  onChange: (datamateId: string) => void;
}

export const DatamatesSelector: FC<DatamatesSelectorProps> = ({
  datamates,
  selectedDatamate,
  onChange,
}) => {
  const datamateName = useMemo(() => {
    return datamates.find(datamate => datamate.id === selectedDatamate)?.name;
  }, [datamates, selectedDatamate]);
  return (
    <>
      <Label className="al-text-sm al-font-medium al-block al-mb-2">
        Select an existing Datamate or create a new one:
      </Label>
      <Select value={selectedDatamate} onValueChange={onChange}>
        <SelectTrigger className="al-w-full">
          {datamateName ?? <SelectValue placeholder="Choose a Datamate" />}
        </SelectTrigger>
        <SelectContent>
          {datamates.map(datamate => (
            <SelectItem key={datamate.name} value={datamate.id || datamate.name}>
              <span>{datamate.name}</span>
              <Stack direction={"column"} gap={"xs"}>
                {datamate.description && (
                  <span className="al-text-xs al-text-muted-foreground al-truncate">
                    {datamate.description}
                  </span>
                )}
              </Stack>
            </SelectItem>
          ))}
          <Button
            className={"al-mt-2 al-w-full"}
            variant={"outline"}
            onClick={() => window.open("/datamates/create", "_blank")}
          >
            Create New Datamate
            <IconExternalLink />
          </Button>
        </SelectContent>
      </Select>
      <p className="al-text-xs al-text-muted-foreground al-mt-4">
        Select a Datamate with Jira access to automatically create and manage tickets for Cost
        Saving Opportunities.
      </p>
    </>
  );
};
